// number formatter to get abbreviated numbers,
// e.g. 100000 -> 100k
export const compactFormatter = new Intl.NumberFormat("en-US", { notation: "compact" });

// e.g. 100000 -> 100,000
export const standardFormatter = new Intl.NumberFormat("en-US", { notation: "standard" });
